import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export const Footer = ({ data }) => {
  if (!data) return null;

  return (
    <footer className="site-footer">
      <div className="section-container">
        <div className="footer-inner">
          <div className="footer-brand">
            <img src="/img/logos/Logo_ReCoPilot.png" alt="" className="footer-logo" />
            <span className="footer-brand-name">{data.brand}</span>
          </div>
          <div className="footer-links">
            {data.links?.map((link, i) => (
              <Link key={i} to={link.href} className="footer-link">
                {link.label}
              </Link>
            ))}
            <a href={`mailto:${data.email}`} className="footer-link">
              {data.email}
            </a>
          </div>
          <p className="footer-copyright">© {data.copyright}</p>
        </div>
      </div>
    </footer>
  );
};
